import React, { useEffect , useMemo, useState} from 'react';
import { View, StyleSheet, Pressable, Text } from 'react-native';
import colors from '../../../../config/colors';


const YearPicker = ({onDateChange, selectedYear: initialSelectedYear} : {onDateChange: (year: number) => void, selectedYear: number}) => {

    const [selectedYear, setSelectedYear] = useState(initialSelectedYear || new Date().getFullYear());


    const years = useMemo(() => {
        const currYear = new Date().getFullYear();
        const yearsArray: number[] = [];
        for (let i = 0; i < 12; i++) {
            yearsArray.push(currYear - i);
        }
        return yearsArray;
    }, []);

    const handleOnPress = (year) => {
        setSelectedYear(year);
        onDateChange(year);
    }


	return (
        <View style={styles.yearGrid}>
            {years.map((year, index) => ( 
                <Pressable key={index} onPress={() => handleOnPress(year)} 
                    style={ ({ hovered }) => [
                        styles.segment,
                        hovered && styles.segmentHover,
                        selectedYear === year && styles.segmentSelected
                ]}>
                    <Text style={[
                        styles.segmentText,
                        selectedYear === year && { color: 'white', fontWeight: '500' }
                    ]}>
                        {year}
                    </Text>
                </Pressable>
            ))}
        </View>
	);
};

const styles = StyleSheet.create({
    yearGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(4, 1fr)',
        gap: 12,
        flex: 1,
        paddingHorizontal: 16,
        paddingVertical: 32,
    },
    segmentText: {
        fontSize: 14,
        color: colors.darkGrey,
        fontWeight: '400',
        //fontFamily: 'Rubik',
    },
    segment: {
            flex: 1,
            padding: 10,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 5,
        },
        segmentHover: {
            backgroundColor: colors.iconBG,
        },
        segmentSelected: {
            backgroundColor: colors.datepickerChooseBG,  
        },
});

export default YearPicker;
